var map = {
	"./attendance/index.jsx": 68390,
	"./calendar/index.jsx": 50026,
	"./chat/index.jsx": 34592,
	"./company-settings/admins.jsx": 71247,
	"./company-settings/approval-flow.jsx": 70619,
	"./company-settings/approved-flow.jsx": 50516,
	"./company-settings/branches.jsx": 97529,
	"./company-settings/branchview-details.jsx": 24131,
	"./company-settings/cash-types.jsx": 31520,
	"./company-settings/chart-builder.jsx": 41403,
	"./company-settings/company.jsx": 4569,
	"./company-settings/companyview-details.jsx": 45305,
	"./company-settings/department-details.jsx": 28377,
	"./company-settings/departments.jsx": 2281,
	"./company-settings/holiday-details.jsx": 65736,
	"./company-settings/holidays.jsx": 35436,
	"./company-settings/index.jsx": 84400,
	"./company-settings/leave-flow-details.jsx": 63398,
	"./company-settings/leave-flow.jsx": 55299,
	"./company-settings/leave-types.jsx": 8176,
	"./company-settings/level-details.jsx": 92479,
	"./company-settings/levels.jsx": 12119,
	"./company-settings/levelview-details.jsx": 14148,
	"./company-settings/media-details.jsx": 85010,
	"./company-settings/media.jsx": 780,
	"./company-settings/new-permission.jsx": 31492,
	"./company-settings/notifications.jsx": 46005,
	"./company-settings/org-chart.jsx": 63158,
	"./company-settings/permission.jsx": 85668,
	"./company-settings/permissions.jsx": 15701,
	"./company-settings/permissionview-details.jsx": 85448,
	"./company-settings/position.jsx": 78776,
	"./company-settings/positionview-details.jsx": 36393,
	"./company-settings/recruitment.jsx": 29891,
	"./company-settings/role.jsx": 37738,
	"./company-settings/roleview-details.jsx": 77850,
	"./company-settings/staff-birthdays.jsx": 75116,
	"./company-settings/subscription.jsx": 83160,
	"./company-settings/tools.jsx": 66246,
	"./company-settings/view-details.jsx": 56774,
	"./company-settings/work-anniversaries.jsx": 75037,
	"./conflict-resolution/[id].jsx": 67317,
	"./conflict-resolution/index.jsx": 92721,
	"./contract-access.jsx": 57460,
	"./contract-staff/form.jsx": 83612,
	"./contract-staff/index.jsx": 65335,
	"./contract-staff/index.test.jsx": 92703,
	"./contract-staff/work.jsx": 97952,
	"./dashboard/[id].jsx": 6919,
	"./dashboard/index.jsx": 89858,
	"./dashboard/workCelebrant.jsx": 37591,
	"./e-wallet/derek-food-panel.jsx": 27810,
	"./e-wallet/index.jsx": 63828,
	"./e-wallet/telecom-panel.jsx": 79177,
	"./employee-dashboard/career-grading.jsx": 27390,
	"./employee-dashboard/index.jsx": 74363,
	"./employee/employeeHeader.jsx": 43015,
	"./employee/employeespage.jsx": 98595,
	"./employee/index.jsx": 70128,
	"./employee/new-employee.jsx": 78569,
	"./engagement/[id].jsx": 57132,
	"./engagement/index.jsx": 77363,
	"./guarantor-forms/index.jsx": 34202,
	"./index.jsx": 50322,
	"./job-descriptions/index.jsx": 34167,
	"./learning-management/index.jsx": 64694,
	"./notification/index.jsx": 59640,
	"./notification/notification-details.jsx": 25731,
	"./organization-setup/index.jsx": 43691,
	"./payroll/PayrollPanels.jsx": 26606,
	"./payroll/SavingsPanels.jsx": 4455,
	"./payroll/index.jsx": 62537,
	"./performance-evaluation/[id].jsx": 86507,
	"./performance-evaluation/evaluation-details.jsx": 65033,
	"./performance-evaluation/index.jsx": 52022,
	"./performance-evaluation/new-evaluation.jsx": 38333,
	"./performance-evaluation/performance-position.jsx": 80431,
	"./productivity/index.jsx": 77654,
	"./productivity/my-tasks.jsx": 80386,
	"./productivity/project-details.jsx": 97907,
	"./productivity/projects.jsx": 40710,
	"./productivity/task-details.jsx": 10827,
	"./productivity/time-management.jsx": 81224,
	"./productivity/time-report.jsx": 51500,
	"./productivity/timesheet.jsx": 92312,
	"./profile/OrganizationProfile.jsx": 90636,
	"./profile/index.jsx": 14070,
	"./query-management/admin-queries.jsx": 45678,
	"./query-management/allQueries.jsx": 46210,
	"./query-management/employee-queries-fixed.jsx": 75431,
	"./query-management/employee-queries.jsx": 15355,
	"./query-management/index.jsx": 91048,
	"./query-management/new-query.jsx": 37423,
	"./query-management/query-details.jsx": 66359,
	"./recruitement/candidate-details.jsx": 78186,
	"./recruitement/index.jsx": 74497,
	"./recruitement/recruitmentflow.jsx": 60257,
	"./recruitement/recruitmentpage.jsx": 69069,
	"./reporting/Recommendations.jsx": 7682,
	"./reporting/Recommendations.test.jsx": 92514,
	"./reporting/ReportCharts.jsx": 95997,
	"./reporting/index.jsx": 83622,
	"./reporting/index.test.jsx": 63403,
	"./reporting/recommendationRules.js": 46199,
	"./requests/card-request.jsx": 95285,
	"./requests/index.jsx": 7610,
	"./requests/leave-types.jsx": 5521,
	"./requests/request-details.jsx": 38796,
	"./requests/requestTable.jsx": 90919,
	"./resources/assets-view.jsx": 33378,
	"./resources/document-table.jsx": 33119,
	"./resources/files-table.jsx": 94043,
	"./resources/folder-page/folder-open-page.jsx": 99778,
	"./resources/folders.jsx": 61465,
	"./resources/index.jsx": 51133,
	"./resources/open-folder.jsx": 6282,
	"./support-center/index.jsx": 76575,
	"./surveys/index.jsx": 93506,
	"./talent-management/index.jsx": 72096,
	"./talent-management/live.jsx": 22737
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42082;